var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3037_24637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8538 30.3034L16.5478 30.9192L18.8895 28.4092H10.1079V8.02734H25.8647L24.5942 15.0221L18.8895 16.0596V24.3596L16.5478 25.0624L14.8538 30.3034Z",
    fill: "#FDF2EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7839 -20.2163C34.7839 20.1367 4.92068 46.2816 1.60566 49.6486H-39.2432L-36.428 48.8842C-36.019 48.6869 -35.2853 48.4486 -33.7753 48.164C-10.068 43.695 23.3236 27.8009 34.7839 -20.2163Z",
    fill: "#1B161D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3869 16.1809H18.3547V16.2243C18.3654 16.2099 18.3762 16.1954 18.3869 16.1809ZM9.62744 41.3005V47.9652H18.3547V32.3962H32.3613V24.531H21.8994C17.7871 31.4563 13.34 37.1002 9.62744 41.3005ZM26.3409 16.1809H35.001V8.1001H29.6979C28.682 10.9197 27.5507 13.6152 26.3409 16.1809Z",
    fill: "#FDE7B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.20a467e4833c2f05bfb0573e6b47260e.svg";
export { ForwardRef as ReactComponent };